import { createAsyncThunk } from '@reduxjs/toolkit';
import APIDataProvider, {
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api/ApiDataProvider';
import { ApiPaths } from '../../../api/APIPaths';
import { ITutor } from '.';

export type TGetTutor = {
  id: string;
  country?: string;
  curriculum?: string;
  grade?: string;
};

export type TGetTutors = {
  limit: number;
  offset: number;
  country: string;
  curriculum?: string;
  subject?: string;
  grade?: string;
};

const apiDataProvider = new APIDataProvider();

export const getTutor = createAsyncThunk(
  '/tutor/get',
  async (data: TGetTutor) => {
    let path = `${ApiPaths.tutors}/${data.id}`;

    const queryParams = new URLSearchParams();

    if (data.country) {
      queryParams.append('country', data.country);
    }
    if (data.curriculum) {
      queryParams.append('curriculum', data.curriculum);
    }
    if (data.grade) {
      queryParams.append('grade', data.grade);
    }

    if (queryParams.toString()) {
      path += `?${queryParams.toString()}`;
    }

    const response = await apiDataProvider.get<TApiResponse<ITutor>>(path);

    return response.data;
  }
);

const getTutorsModule = async (data: TGetTutors) => {
  const queryParams = new URLSearchParams({
    limit: String(data.limit),
    offset: String(data.offset),
    country: data.country,
  });

  if (data.curriculum) {
    queryParams.append('curriculum', data.curriculum);
  }

  if (data.subject) {
    queryParams.append('subject', data.subject);
  }

  if (data.grade) {
    queryParams.append('grade', data.grade);
  }

  const path = `${ApiPaths.tutors}?${queryParams.toString()}`;

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<ITutor>>
  >(path);

  return response.data;
};

export const getTutors = createAsyncThunk('/tutor/list', getTutorsModule);

export const loadMoreTutors = createAsyncThunk(
  '/tutor/loadMore',
  getTutorsModule
);
